module.exports = __webpack_public_path__ + "static/media/SHRIRAMFIN.81d11956.txt";